import * as React from 'react';
import { connect } from 'react-redux';
import './WarrantyQuestions.css';
import { handleNextStep , setQuoteData } from '../../../../actions/salesActions';
import { Card } from 'react-bootstrap'; 
import { showModalRegisteredInSouthAfrica, showModalPerformanceMods, showModalServiceHistory, showModalWarrantyInsurance, showModalKiloCheck } from '../../../../actions/salesModalActions'

class WarrantyQuestions extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            registerSouthAfricaQuestion: undefined,
            performanceModQuestion: undefined,
            serviceHitoryQuestion: undefined,
            currentWarrantyInsuranceQuestion: undefined,
            kilometerChechQuestion: undefined,
            nextDisabled: true,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });

        switch (name) {
            case ('registerSouthAfricaQuestion'):
                if (value === 'no') { this.props.dispatchAction(showModalRegisteredInSouthAfrica()); }
                break;

            case ('performanceModQuestion'):
                if (value === 'yes') { this.props.dispatchAction(showModalPerformanceMods());}
                break;

            case ('serviceHitoryQuestion'):
                if (value === 'no') { this.props.dispatchAction(showModalServiceHistory()); }
                break;

            case ('currentWarrantyInsuranceQuestion'):
                if (value === 'yes') { this.props.dispatchAction(showModalWarrantyInsurance()); }
                break;

            case ('kilometerChechQuestion'):
                if (value === 'yes') { this.props.dispatchAction(showModalKiloCheck()); }
                break;
        }
        this.checkSubmit();
    }

    async checkSubmit() {
        let disabled = false
        if (this.state.registerSouthAfricaQuestion === undefined || this.state.registerSouthAfricaQuestion === 'no') {
            disabled = true
        }
        if (this.state.performanceModQuestion === undefined || this.state.performanceModQuestion === 'yes') {
            disabled = true
        }
        if (this.state.serviceHitoryQuestion === undefined || this.state.serviceHitoryQuestion === 'no') {
            disabled = true
        }
        if (this.state.kilometerChechQuestion === undefined || this.state.kilometerChechQuestion === 'yes') {
            disabled = true
        }
        this.setState({ nextDisabled: disabled })
    }

    async handleNextStep() {
        await this.checkSubmit();
        if (this.state.nextDisabled === false) {
            let payload = {
                carRegisteredLocally: this.state.registerSouthAfricaQuestion === 'yes' ? true : false,
                performanceModification: this.state.performanceModQuestion === 'yes' ? true : false,
                fullServiceHistory: this.state.serviceHitoryQuestion === 'yes' ? true : false,
                existingWarranty: this.state.currentWarrantyInsuranceQuestion === 'yes' ? true : false,
            }
            await this.props.dispatchAction(setQuoteData(payload));

            await this.props.dispatchAction(handleNextStep());
        }
    }
   
    public render() {
        return (
        <div>                                  
            <div className="container mt-40px">
                <Card className="content-box-padding-20px-with-box-shadow legalQuestion">
                    <div className="row noma">
                        <div className="col-12 nopa" >
                            <div className="row noma legalsection-parent-row">
                                <div className="col nopa">
                                    <div className="row noma">
                                        <div className="judgement-question-col nopa">
                                            <p className="warranty-questions-text mt-2">Is the car registered in South Africa</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="nopa text-lg-right legal-section-button-col">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <button className={(this.state.registerSouthAfricaQuestion === 'no' && this.state.registerSouthAfricaQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnRegisterSouthAfricaQuestionNo' value='no' name='registerSouthAfricaQuestion' onClick={this.handleChange}>No</button>
                                        </div>
                                        <div className="legal-section-mobile-gutter nopa"></div>
                                        <div className="col nopa">
                                            <button className={(this.state.registerSouthAfricaQuestion === 'yes' && this.state.registerSouthAfricaQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} value='yes' id='btnRegisterSouthAfricaQuestionYes' name='registerSouthAfricaQuestion' onClick={this.handleChange}>Yes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="mb-18px mt-19px legalsection-hr-2px" />
                        </div >
                        <div className="col-12 nopa" >
                            <div className="row noma legalsection-parent-row">
                                <div className="col nopa">
                                    <div className="row noma">
                                        <div className="judgement-question-col nopa">
                                            <p className="warranty-questions-text mt-2">Has the car been modified in any way to increase its performance</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="nopa text-lg-right legal-section-button-col">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <button className={(this.state.performanceModQuestion === 'no' && this.state.performanceModQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnPerformanceModQuestionNo' value='no' name='performanceModQuestion' onClick={this.handleChange}>No</button>
                                        </div>
                                        <div className="legal-section-mobile-gutter nopa"></div>
                                        <div className="col nopa">
                                            <button className={(this.state.performanceModQuestion === 'yes' && this.state.registerSouthAfricaQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnPerformanceModQuestionYes' value='yes' name='performanceModQuestion' onClick={this.handleChange}>Yes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="mb-18px mt-19px legalsection-hr-2px" />
                        </div >
                        <div className="col-12 nopa" >
                            <div className="row noma legalsection-parent-row">
                                <div className="col nopa">
                                    <div className="row noma">
                                        <div className="judgement-question-col nopa">
                                            <p className="warranty-questions-text mt-2">Does the car have a full service history from an accredited provider</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="nopa text-lg-right legal-section-button-col">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <button className={(this.state.serviceHitoryQuestion === 'no' && this.state.serviceHitoryQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnServiceHitoryQuestionNo' value='no' name='serviceHitoryQuestion' onClick={this.handleChange}>No</button>
                                        </div>
                                        <div className="legal-section-mobile-gutter nopa"></div>
                                        <div className="col nopa">
                                            <button className={(this.state.serviceHitoryQuestion === 'yes' && this.state.serviceHitoryQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnServiceHitoryQuestionYes' value='yes' name='serviceHitoryQuestion' onClick={this.handleChange}>Yes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="mb-18px mt-19px legalsection-hr-2px" />
                        </div >
                        <div className="col-12 nopa" >
                            <div className="row noma legalsection-parent-row">
                                <div className="col nopa">
                                    <div className="row noma">
                                        <div className="judgement-question-col nopa">
                                            <p className="warranty-questions-text mt-2">Do you currently have car warranty insurance elsewhere</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="nopa text-lg-right legal-section-button-col">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <button className={(this.state.currentWarrantyInsuranceQuestion === 'no' && this.state.currentWarrantyInsuranceQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnCurrentWarrantyInsuranceQuestionNo' value='no' name='currentWarrantyInsuranceQuestion' onClick={this.handleChange}>No</button>
                                        </div>
                                        <div className="legal-section-mobile-gutter nopa"></div>
                                        <div className="col nopa">
                                            <button className={(this.state.currentWarrantyInsuranceQuestion === 'yes' && this.state.currentWarrantyInsuranceQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnCurrentWarrantyInsuranceQuestionYes' value='yes' name='currentWarrantyInsuranceQuestion' onClick={this.handleChange}>Yes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="mb-18px mt-19px legalsection-hr-2px" />
                        </div >
                        <div className="col-12 nopa" >
                            <div className="row noma legalsection-parent-row">
                                <div className="col nopa">
                                    <div className="row noma">
                                        <div className="judgement-question-col nopa">
                                            <p className="warranty-questions-text mt-2">Do you have more than 200,000kms on your car</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="nopa text-lg-right legal-section-button-col">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <button className={(this.state.kilometerChechQuestion === 'no' && this.state.kilometerChechQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnKilometerChechQuestionNo' value='no' name='kilometerChechQuestion' onClick={this.handleChange}>No</button>
                                        </div>
                                        <div className="legal-section-mobile-gutter nopa"></div>
                                        <div className="col nopa">
                                            <button className={(this.state.kilometerChechQuestion === 'yes' && this.state.kilometerChechQuestion !== undefined) ? 'btn btn-outline-dark nopa legal-section-button active' : 'btn btn-outline-dark nopa legal-section-button'} id='btnKilometerChechQuestionYes' value='yes' name='kilometerChechQuestion' onClick={this.handleChange}>Yes</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    </div>
                </Card>
            </div>          
                <div className="text-center">               
                <button className="btn btn-solid-red mt-5 pt-2" id='Next' style={{ width: '250px', height: '50px' }} disabled={this.state.nextDisabled } onClick={this.handleNextStep }>Next</button>
            </div>
        </div> 
        )
    }
}

const mapStateToProps = (state: any) => {
    return {}
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
} 

export default connect(mapStateToProps, mapDispatchToProps)(WarrantyQuestions);